import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { stagger, useAnimate } from "framer-motion";
import { getBrandColorHex } from "theme/colors";
import { AidNotifications } from "./aid-notifications";
import { Tree } from "./tree";

const violet900 = getBrandColorHex("violet", 900);
const violet500 = getBrandColorHex("violet", 500);

function useTreeAnimation(isActive: boolean) {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const triggerAnimation = async () => {
      await animate(
        isActive
          ? [
              [
                ".tree-node",
                { opacity: [0, 1], scale: [0, 1] },
                { at: "-0.2", delay: stagger(0.07), duration: 0.35, type: "spring" },
              ],
              [
                ".tree-path",
                { opacity: [0, 1], pathLength: [0, 1] },
                { at: "-0.8", delay: stagger(0.07), duration: 0.35, ease: "easeOut" },
              ],
              [
                ".aid-icon",
                { color: [violet500, violet900] },
                { at: "-0.85", delay: stagger(0.05), duration: 0.35, type: "spring" },
              ],
            ]
          : [
              // Reset
              [".tree-node", { opacity: [1, 0], scale: [1, 0] }, { at: "-0.2", duration: 0.35, type: "spring" }],
              [".tree-path", { opacity: [1, 0], pathLength: [1, 0] }, { at: "-0.8", duration: 0.4, ease: "easeOut" }],
              [".aid-icon", { color: [violet900, violet500] }, { at: "-0.8", duration: 0.35, type: "spring" }],
            ],
      );
    };

    // Do not need `await` because there is no action after the promise
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    triggerAnimation();
  }, [isActive, animate]);

  return scope;
}

export function AidAnimation({ isCardHovered }: { isCardHovered: boolean }) {
  const [animationActive, setAnimationActive] = useState(false);
  const scope = useTreeAnimation(animationActive);

  useEffect(() => {
    setAnimationActive(isCardHovered);
  }, [isCardHovered]);

  return (
    <Box ref={scope} className="group" boxSize="100%" pos="relative">
      <Tree isStatic color="new.violet.500" />
      <Tree
        color="rgba(66, 27, 176, 0.8)" // XX new.violet.900 w/ opacity adjustment
      />
      <AidNotifications />
    </Box>
  );
}
